/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Connection_Error_Connection_DescInputs */



/**
* | output |
* | --- |
* | "Our status page reports oneAI as operational, so the problem is most likely your own network. You're still signed in — this is not a sign-out." |
*
* @param {Auth_Connection_Error_Connection_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_connection_error_connection_desc = /** @type {((inputs?: Auth_Connection_Error_Connection_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Connection_Error_Connection_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unsere Statusseite meldet oneAI als betriebsbereit — das Problem liegt daher wahrscheinlich in deinem eigenen Netzwerk. Du bist weiterhin angemeldet, dies ist keine Abmeldung.")
	return /** @type {LocalizedString} */ ("Our status page reports oneAI as operational, so the problem is most likely your own network. You're still signed in — this is not a sign-out.")
});